
import { PaymentStatusData, GroupedPayments } from "../types/payment-status";

export const formatTime = (time: string) => {
  const [hours, minutes] = time.split(':');
  const period = Number(hours) >= 12 ? 'PM' : 'AM';
  const hour12 = Number(hours) % 12 || 12;
  return `${hour12}:${minutes} ${period}`;
};

export const groupPaymentsByTimeSlot = (payments: PaymentStatusData[]): GroupedPayments => {
  return payments.reduce((acc, payment) => {
    if (!payment.time_slot) return acc;
    
    const timeSlotKey = `${payment.time_slot.date}-${payment.time_slot.start_time}`;
    
    if (!acc[timeSlotKey]) {
      acc[timeSlotKey] = {
        date: payment.time_slot.date,
        time: payment.time_slot.start_time,
        max_players: payment.time_slot.max_players,
        booked_players: Number(payment.time_slot.booked_players) || 0,
        paid_players: Number(payment.time_slot.paid_players) || 0,
        reserved_slots: Number(payment.time_slot.reserved_slots) || 0,
        reserved_paid_slots: Number(payment.time_slot.reserved_paid_slots) || 0,
        paid: [],
        pending: []
      };
    }

    // Only add to paid/pending arrays if we have valid player data
    if (payment.player && payment.player.full_name) {
      if (payment.status === 'paid') {
        acc[timeSlotKey].paid.push(payment);
      } else {
        acc[timeSlotKey].pending.push(payment);
      }
    }

    return acc;
  }, {} as GroupedPayments);
};
